import { defineComponent as _defineComponent } from 'vue'
import { ref, nextTick } from "vue";
import { Image } from "element-ui";
// 引入个图占位，防止报错

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props, { expose }) {

const defaultImg = require("../../../assets/imgs/default-avatar.png");

// 图片预览初始图片index
const initialIndex = ref<number>(0);
// 预览图片列表
const srcList = ref<string[]>([]);

const elImageRef = ref<Image>();

/**
 * 预览
 * @param {string[] | string} imgs 预览图片列表
 * @param {number} [index] 默认从第几张开始预览
 * @returns {void}
 */
function show(imgs: string | string[], index = 0) {
  initialIndex.value = index;
  if (!Array.isArray(imgs)) {
    imgs = [imgs];
  }
  srcList.value = imgs;
  nextTick(() => {
    elImageRef.value && (elImageRef as any).value.clickHandler();
  });
}

expose({
  show,
});

return { __sfc: true,defaultImg, initialIndex, srcList, elImageRef, show }
}

})